export default "__VITE_PUBLIC_ASSET__e65e3c2d__"